import { createContext, useContext } from 'react'
import Interface from '@/apis'

const interfaceContext = createContext(Interface)

export const useInterface = <T extends keyof typeof Interface>(ns: T) => {
  return useContext(interfaceContext)[ns]
}
